import _ from 'lodash';
import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { Card, CardBody, Col, Row } from "reactstrap";
import {
  FilterButton, OnHoldLateBalanceCustomers, SalesDashboardNewOrders, 
  SalesDashboardOpenCars, SalesDashboardSalesCallLog, 
  SalesDashboardShipSchedule, SalesQuotes, TopCustomersBySales
} from ".";
import { toast } from "react-toastify";
import { DesktopContainer } from "../layouts";
import { api, filterHelpers, UserContext, constants } from "../utils";
import axios from 'axios';
import useCookies from 'react-use-cookie';

export default function SalesDashboard(props) {
  const userCtx = useContext(UserContext);
  const [cookies, setSalesCookie] = useCookies(constants.LocalStorageKeys.SalesDashboard, null);
  const [classList, setClassList] = useState([]);
  const [filters, setFilters] = useState([]);
  const [initialized, setIntialized] = useState(false);
  const [salespeopleList, setSalespeopleList] = useState(null);
  const [salesperson, setSalesperson] = useState({value: 'All', label: '--- All ---'});

  useEffect(() => {
    document.title = `Sales Dashboard`
    let foundCookies = cookies;
    if(foundCookies && foundCookies !== "null"){
      let parsedCookies = JSON.parse(foundCookies);
      let filterList = _.map(parsedCookies, c => c);
      setFilters(filterList);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const cancelToken = axios.CancelToken;
    const source = cancelToken.source();

    if (userCtx && !initialized) {
      if (userCtx.customerFilter) {
        userCtx.setCustomerFilter(null);
        setIntialized(true);
      }
    }

    let apiCalls = [];
    apiCalls.push(
      api.fetchS(`Reference/GetSalespeopleList`, {}, source.token).then((response) => {
        if(response.data && response.data.success) {
          return {
            salespeople: response.data.salespeople
          };
        } else {
          return "";
        }
      })
        .catch(api.catchHandler)
    );
    apiCalls.push(
      api.fetchS(`Reference/GetItemClasses`, {}, source.token).then((response) => {
        if(response.data && response.data.success) {
          return {
            itemClasses: _.map(response.data.itemClasses, (x) => {
              return x.itemClass
            })
          };
        } else {
          return "";
        }
      })
        .catch(api.catchHandler)
    );
    Promise.all(apiCalls).then(arrayResults => {
      let aggResults = {};
      _.each(arrayResults, (x) => Object.assign(aggResults, x));
      setSalespeopleList(
        _.chain(aggResults.salespeople)
          .map((sp) => {
            return {
              value: sp.salespersonId,
              label: sp.salespersonText,
            };
          })
          .sortBy((x) => {
            return x.label;
          })
          .unshift({
            value: 'All',
            label: '--- All ---'
          })
          .value()
      );
      setClassList(aggResults.itemClasses)
    }).catch(error => toast.error("There was an error loading sales people data"));

    return () => {
      source.cancel("axios request cancelled");
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function onFilterChange(changedFilter) {
    const filterChanges = filterHelpers.getFilters(filters, changedFilter);
    saveSearchCookie(JSON.stringify(Object.assign({}, filterChanges)));
    setFilters(filterChanges);
  }

  function saveSearchCookie(data) {
    setSalesCookie(data, {
      // path: window.location.pathname,
      domain: window.location.hostname,
      sameSite: "Strict",
      days: 60,
      // maxAge: 60 * 60 * 24 * 60, //5 minutes
      // expires: dateHelpers.addDays(new Date(), 60),
    });
  };

  return (
    <React.Fragment>
      {userCtx.currentUser && userCtx.currentUser.isAnyCustomerTypeRole
        ? null
        : <DesktopContainer screenName="Sales Dashboard">
          <div className="filter-header sticky-top">
            < Row className="justify-content-center mb-2">
              <Col xs="3" lg="2" className="text-end">
                <h4
                  className="pt-1 text-white"
                  children="Sales Person:"
                />
              </Col>
              <Col xs="6">
                <Select
                  classNamePrefix="serviceThreadSelect"
                  filterName="SalesPersonId"
                  options={salespeopleList}
                  value={salesperson}
                  onChange={(e) => setSalesperson(e)}
                  isClearable                  
                />
              </Col>
            </Row>
            <div className="dashboard-button-container">
              <FilterButton
                filterName="topCustomersBySales"
                displayName="Top 25 Customers"
                value={filterHelpers.getValue(filters, "topCustomersBySales")}
                onChangeCallback={(e) => onFilterChange(e)}
              />
              <FilterButton
                filterName="onHoldCustomers"
                displayName="On Hold"
                displayCaptionClassName="fontSize85 filter-definition-caption"
                value={filterHelpers.getValue(filters, "onHoldCustomers")}
                onChangeCallback={(e) => onFilterChange(e)}
              />
              <FilterButton
                filterName="lateBalanceCustomers"
                displayName="Late Balances"
                displayCaptionClassName="fontSize85 filter-definition-caption"
                value={filterHelpers.getValue(filters, "lateBalanceCustomers")}
                onChangeCallback={(e) => onFilterChange(e)}
              />
              <FilterButton
                filterName="salesDashboardNewOrders"
                displayName="New Orders"
                displayCaptionClassName="fontSize85 filter-definition-caption"
                value={filterHelpers.getValue(filters, "salesDashboardNewOrders")}
                onChangeCallback={(e) => onFilterChange(e)}
              />
              <FilterButton
                filterName="salesQuotes"
                displayName="Quotes"
                displayCaptionClassName="fontSize85 filter-definition-caption"
                value={filterHelpers.getValue(filters, "salesQuotes")}
                onChangeCallback={onFilterChange}
              />
              <FilterButton
                filterName="salesDashboardShipSchedule"
                displayName="Ship Schedule"
                displayCaptionClassName="fontSize85 filter-definition-caption"
                value={filterHelpers.getValue(filters, "salesDashboardShipSchedule")}
                onChangeCallback={(e) => onFilterChange(e)}
              />
              <FilterButton
                filterName="salesDashboardOpenCars"
                displayName="Open CARs"
                value={filterHelpers.getValue(filters, "salesDashboardOpenCars")}
                onChangeCallback={(e) => onFilterChange(e)}
              />
              <FilterButton
                filterName="salesDashboardSalesCallLog"
                displayName="Sales Calls"
                value={filterHelpers.getValue(filters, "salesDashboardSalesCallLog")}
                onChangeCallback={(e) => onFilterChange(e)}
              />
            </div>
          </div>
          {
            salesperson && (
              <>
                {filterHelpers.getValue(filters, "salesDashboardNewOrders") && (
                  <Card className="dashboard-card">
                    <CardBody>
                      <SalesDashboardNewOrders
                        salespersonId={salesperson.value === 'All' ? '' : salesperson.value}
                      />
                    </CardBody>
                  </Card>
                )}
                {filterHelpers.getValue(filters, "salesQuotes") && (
                  <Card className="dashboard-card">
                    <CardBody>
                      <SalesQuotes salesId={salesperson.value === 'All' ? '' : salesperson.value} />
                    </CardBody>
                  </Card>
                )}
                {filterHelpers.getValue(filters, "topCustomersBySales") && (
                  <Card className="dashboard-card">
                    <CardBody>
                      <TopCustomersBySales
                        salespersonId={salesperson.value === 'All' ? '' : salesperson.value}
                        classList={classList}
                      />
                    </CardBody>
                  </Card>
                )}
                {filterHelpers.getValue(filters, "onHoldCustomers") && (
                  <Card className="dashboard-card">
                    <CardBody>
                      <OnHoldLateBalanceCustomers
                        salespersonId={salesperson.value === 'All' ? '' : salesperson.value}
                        showOnHoldOnly={true}
                      />
                    </CardBody>
                  </Card>
                )}
                {filterHelpers.getValue(filters, "lateBalanceCustomers") && (
                  <Card className="dashboard-card">
                    <CardBody>
                      <OnHoldLateBalanceCustomers
                        salespersonId={salesperson.value === 'All' ? '' : salesperson.value}
                        showLateBalancesOnly={true}
                      />
                    </CardBody>
                  </Card>
                )}
                {filterHelpers.getValue(filters, "salesDashboardOpenCars") && (
                  <Card className="dashboard-card">
                    <CardBody>
                      <SalesDashboardOpenCars
                        salespersonId={salesperson.value === 'All' ? '' : salesperson.value}
                      />
                    </CardBody>
                  </Card>
                )}
                {filterHelpers.getValue(filters, "salesDashboardSalesCallLog") && (
                  <Card className="dashboard-card">
                    <CardBody>
                      <SalesDashboardSalesCallLog
                        salespersonId={salesperson.value === 'All' ? '' : salesperson.value}
                      />
                    </CardBody>
                  </Card>
                )}
                {filterHelpers.getValue(filters, "salesDashboardShipSchedule") && (
                  <Card className="dashboard-card">
                    <CardBody>
                      <SalesDashboardShipSchedule
                        salespersonId={salesperson.value === 'All' ? '' : salesperson.value}
                      />
                    </CardBody>
                  </Card>
                )}
              </>
            )
          }
        </DesktopContainer>
      }
    </React.Fragment>
  );
}